// import React, { useEffect, useState } from "react";
// import { connect } from "react-redux";
// import { currentRouteSet } from "../../actions/actions";
// import { pathSpliter } from "../../lib/functions";
// import SalesInvoice from "./components/sales_invoice";
// import { API_URL } from "../../config";
// import axios from "axios";
// import Button from "@material-ui/core/Button";
// import TextField from "@material-ui/core/TextField";
// import Autocomplete from "@material-ui/lab/Autocomplete";
// import Grid from "@material-ui/core/Grid";

// let ViewSalesPOInvoice = ({ location, currentRouteSet, authInfo }) => {
//   let [invoices, invoicesSet] = useState([]);
//   let [selectedInvoice, selectedInvoiceSet] = useState(null);
//   let [saleId, saleIdSet] = useState(null);
//   let [institution, institutionSet] = useState(null);
//   let [po_id, po_id_set] = useState("");

//   useEffect(() => {
//     currentRouteSet(pathSpliter(location.pathname, 1));
//     getInstitution();
//   }, []);

//   let getSalesInvoices = async () => {
//     try {
//       const res = await axios.post(
//         `${API_URL}/api/sales-po-invoices`,
//         { po_id: po_id },
//         {
//           headers: { "auth-token": authInfo.token },
//         }
//       );
//       invoicesSet(res.data); // Update state with response data
//     } catch (error) {
//       console.error("Error fetching invoices:", error);
//     }
//   };

//   let getInstitution = async () => {
//     await axios
//       .get(`${API_URL}/api/get-institution`, {
//         headers: { "auth-token": authInfo.token },
//       })
//       .then((res) => {
//         institutionSet(res.data);
//       });
//   };

//   let processedSubmited = async () => {
//     getSalesInvoices();
//   };
//   return (
//     <>
//       <Grid container>
//         <Grid item xs={12} sm={12}>
//           <Grid item xs={12} sm={2}>
//             <TextField
//               label="p.o"
//               variant="outlined"
//               value={po_id}
//               //   className={classes.fullWidth}
//               onChange={(e) => po_id_set(e.target.value)}
//               name="sale_invoice"
//             />
//           </Grid>
//           <Grid container>
//             <Button
//               style={{
//                 marginTop: "5px",
//                 marginLeft: "auto",
//                 fontSize: "14px",
//               }}
//               //   buttonRef={addToCartRef}
//               variant="contained"
//               color="primary"
//               size="small"
//               onClick={() => processedSubmited()}
//               //   className={classes.button}
//               //   startIcon={<SaveIcon />}
//             >
//               Submit
//             </Button>
//           </Grid>
//         </Grid>
//         <Grid
//           xs={12}
//           sm={12}
//           style={{ width: "250px", marginBottom: "20px", margin: "0px auto" }}
//         >
//           <Autocomplete
//             openOnFocus={true}
//             autoHighlight={true}
//             style={{ width: "100%", height: "20px" }}
//             options={invoices}
//             value={selectedInvoice}
//             size="small"
//             getOptionLabel={(option) => option.sale_invoice}
//             onChange={(e, invoice) => {
//               selectedInvoiceSet(invoice);
//               if (invoice != null) {
//                 saleIdSet(invoice.sale_id);
//               }
//             }}
//             renderInput={(params) => (
//               <TextField
//                 {...params}
//                 label="Choose Sales Invoice"
//                 variant="outlined"
//               />
//             )}
//           />
//         </Grid>
//       </Grid>

//       {<SalesInvoice saleId={saleId} institution={institution} />}
//     </>
//   );
// };

// const mapStateToPops = (state) => {
//   return {
//     currentRoute: state.currentRouteReducer,
//     authInfo: state.authInfoReducer,
//   };
// };

// export default connect(mapStateToPops, { currentRouteSet })(ViewSalesPOInvoice);

import React, { useEffect, useState } from "react";
import { connect } from "react-redux";
import { currentRouteSet } from "../../actions/actions";
import { pathSpliter } from "../../lib/functions";
import SalesInvoice from "./components/sales_invoice";
import { API_URL } from "../../config";
import axios from "axios";
import Button from "@material-ui/core/Button";
import TextField from "@material-ui/core/TextField";
import Autocomplete from "@material-ui/lab/Autocomplete";
import Grid from "@material-ui/core/Grid";
import CircularProgress from "@material-ui/core/CircularProgress";

let ViewSalesPOInvoice = ({ location, history, currentRouteSet, authInfo }) => {
  let [invoices, invoicesSet] = useState([]);
  let [selectedInvoice, selectedInvoiceSet] = useState(null);
  let [saleId, saleIdSet] = useState(null);
  let [institution, institutionSet] = useState(null);
  let [po_id, po_id_set] = useState("");
  let [loading, loadingSet] = useState(false);
  let [open, setOpen] = useState(false);

  useEffect(() => {
    currentRouteSet(pathSpliter(location.pathname, 1));
    getInstitution();
  }, []);

  useEffect(() => {
    if (invoices.length > 0) {
      //alert("Sales PO Invoices Fetch Successfully");
    }
  }, [invoices]);

  let getSalesInvoices = async () => {
    loadingSet(true);
    try {
      const res = await axios.post(
        `${API_URL}/api/sales-po-invoices`,
        { po_id: po_id },
        {
          headers: { "auth-token": authInfo.token },
        }
      );
      invoicesSet(res.data); // Update state with response data
      loadingSet(false);
      setOpen(true);
    } catch (error) {
      console.error("Error fetching invoices:", error);
      loadingSet(false);
      setOpen(true);
    }
  };

  let getInstitution = async () => {
    await axios
      .get(`${API_URL}/api/get-institution`, {
        headers: { "auth-token": authInfo.token },
      })
      .then((res) => {
        institutionSet(res.data);
      });
  };

  let processedSubmited = async () => {
    getSalesInvoices();
  };

  return (
    <Grid container direction="column" alignItems="center" spacing={2}>
      <Grid item>
        <Grid container alignItems="center" spacing={1}>
          <Grid item>
            <TextField
              label="Chalan Number"
              variant="outlined"
              value={po_id}
              onChange={(e) => po_id_set(e.target.value)}
              name="sale_invoice"
            />
          </Grid>
          <Grid item>
            <Button
              variant="contained"
              color="primary"
              size="small"
              onClick={() => processedSubmited()}
            >
              Submit
            </Button>
          </Grid>
        </Grid>
      </Grid>

      <Grid item style={{ width: "100%", maxWidth: "400px" }}>
        <Autocomplete
          open={open}
          onOpen={() => {
            setOpen(true);
          }}
          onClose={() => {
            setOpen(false);
          }}
          autoHighlight={true}
          options={invoices}
          noOptionsText="Not Found"
          value={selectedInvoice}
          size="small"
          getOptionLabel={(option) => option.sale_invoice}
          onChange={(e, invoice) => {
            selectedInvoiceSet(invoice);
            if (invoice != null) {
              saleIdSet(invoice.sale_id);
            }
          }}
          renderInput={(params) => (
            <TextField
              {...params}
              label="Choose Sales PO Invoice"
              variant="outlined"
              InputProps={{
                ...params.InputProps,
                endAdornment: (
                  <React.Fragment>
                    {loading ? <CircularProgress color="primary" size={20} /> : null}
                    {params.InputProps.endAdornment}
                  </React.Fragment>
                ),
              }}
            />
          )}
        />
      </Grid>
      <Grid item style={{ width: "100%", marginTop: "10px" }}>
        <SalesInvoice saleId={saleId} institution={institution} history={history} />
      </Grid>
    </Grid>
  );
};

const mapStateToPops = (state) => {
  return {
    currentRoute: state.currentRouteReducer,
    authInfo: state.authInfoReducer,
  };
};

export default connect(mapStateToPops, { currentRouteSet })(ViewSalesPOInvoice);
